import { useTranslation } from "react-i18next"
import { Button, Input } from "components"
import { Box } from "theme-ui"
export const Password = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div>
   <div className="w-[96%] mx-auto mt-6">
    <h1 className="Jakarta-font font-semibold pb-3">{t("changeIdentity")}</h1>
    <Box bg="highlight" className="Jakarta-font py-5 px-4 rounded">
     <h1 className="font-semibold">{t("changePassword")}</h1>
     <div className="flex justify-between py-4">
      <div className="flex flex-col justify-center w-[48%]">
       <Input
        label={`${t("newPassword")}:`}
        id="Neues"
        className="bg-gray py-2 outline-none rounded px-2 text-black"
        type="text"
        placeholder="testName"
       />
      </div>
      <div className="flex flex-col justify-center w-[48%]">
       <Input
        label={`${t("passwordConfirmation")}:`}
        id="email"
        className="bg-gray py-2 outline-none rounded px-2 text-black"
        type="email"
        placeholder="test@gmail.com"
       />
      </div>
     </div>
     <div className="flex justify-end">
      <div>
       <Button size={"xl"}>{t("save")}</Button>
      </div>
     </div>
    </Box>
   </div>
  </div>
 )
}
